import * as React from "react";
import type { SVGProps } from "react";
interface SVGRProps {
  title?: string;
  titleId?: string;
}
const SvgPoint = ({
  title,
  titleId,
  ...props
}: SVGProps<SVGSVGElement> & SVGRProps) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1em"
    height="1em"
    fill="none"
    viewBox="0 0 22 23"
    aria-labelledby={titleId}
    {...props}
  >
    {title ? <title id={titleId}>{title}</title> : null}
    <path
      fill="#007A3D"
      d="m10.631 4.414-5.28 6.312a1.216 1.216 0 0 0 0 1.552l5.28 6.312a1.128 1.128 0 0 0 1.738 0l5.28-6.312a1.216 1.216 0 0 0 0-1.552l-5.28-6.312a1.12 1.12 0 0 0-1.738 0"
    />
  </svg>
);
export default SvgPoint;
